import { FieldProps } from './assetDataMapper';
import { AssetType } from './getAssetData';

/**
 * Get the asset data by asset type
 * @param assetType - The asset type
 * @param fields - The fields
 * @returns The asset data
 */
export const getAssetDataByAssetType = (
  assetType: AssetType | undefined,
  {
    expressInterestText,
    highAndMediumVoltageCapacityTextFirstPart,
    highAndMediumVoltageCapacityTextSecondPart,
    highAndMediumVoltageHowAndWhenText,
    highAndMediumVoltageIntroText,
    highAndMediumVoltageNotableAspectsText,
    highVoltageCapacityTextFirstPart,
    highVoltageCapacityTextSecondPart,
    highVoltageHowAndWhenText,
    highVoltageIntroText,
    highVoltageNotableAspectsText,
    mediumVoltageCapacityTextFirstPart,
    mediumVoltageCapacityTextSecondPart,
    mediumVoltageHowAndWhenText,
    mediumVoltageIntroText,
    mediumVoltageNotableAspectsText,
  }: FieldProps
) => {
  switch (assetType) {
    case 'BothMainAndUnderlyingAssets':
      return {
        expressInterestText: expressInterestText?.toString(),
        howAndWhenText: highAndMediumVoltageHowAndWhenText?.toString(),
        introText: highAndMediumVoltageIntroText?.toString(),
        capacityTextFirstPart: highAndMediumVoltageCapacityTextFirstPart?.toString(),
        capacityTextSecondPart: highAndMediumVoltageCapacityTextSecondPart?.toString(),
        notableAspectsText: highAndMediumVoltageNotableAspectsText,
      };
    case 'MainAssetOnly':
      return {
        expressInterestText: expressInterestText?.toString(),
        howAndWhenText: highVoltageHowAndWhenText?.toString(),
        introText: highVoltageIntroText?.toString(),
        capacityTextFirstPart: highVoltageCapacityTextFirstPart?.toString(),
        capacityTextSecondPart: highVoltageCapacityTextSecondPart?.toString(),
        notableAspectsText: highVoltageNotableAspectsText,
      };
    case 'UnderlyingAssetsOnly':
      return {
        expressInterestText: expressInterestText?.toString(),
        howAndWhenText: mediumVoltageHowAndWhenText?.toString(),
        introText: mediumVoltageIntroText?.toString(),
        capacityTextFirstPart: mediumVoltageCapacityTextFirstPart?.toString(),
        capacityTextSecondPart: mediumVoltageCapacityTextSecondPart?.toString(),
        notableAspectsText: mediumVoltageNotableAspectsText,
      };
    case 'NoScarcity':
    default:
      return null;
  }
};
